<template>
  <v-card class="base-card shadow">
    <v-card-title>
      <strong>Персональные данные</strong>
    </v-card-title>

    <v-card-text class="pb-6">
      <SimpleTextRow
        name="Фамилия"
        v-model="employee.lastName"
      />
      <SimpleTextRow
        name="Имя"
        v-model="employee.firstName"
      />
      <SimpleTextRow
        name="Отчество"
        v-model="employee.middleName"
      />
      <SimpleTextRow
        name="Учёная степень"
        :value="employee?.academicDegree?.name"
        hide-border-bottom
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash'
import { Employee } from '../../models'
import SimpleTextRow from '../ui/SimpleTextRow'

export default {
  name: 'PositionsCard',

  props: {
    selectedEmployee: Object
  },

  components: {
    SimpleTextRow
  },

  data: () => {
    return {
      employee: new Employee()
    }
  },

  watch: {
    selectedEmployee: {
      deep: true,
      immediate: true,
      handler(val) {
        this.employee = cloneDeep(val)
      }
    }
  }
}
</script>

<style scoped></style>
